import React from 'react';
import { useHelpers } from '../../providers/HelpersProvider';

export default function Modifier({ name, price, quantity, isNested }) {
  const { formatCurrency } = useHelpers();
  const modifierIcon = isNested ? '+' : '•';
  const quantityTitle = ` ${quantity}x`;

  return (
    <div className="grid grid-cols-12">
      <span />
      <span className="col-span-8 md:col-span-9 pl-md">
        {modifierIcon}
        {quantity > 1 && <span className="font-bold">{quantityTitle}</span>}
        &nbsp;
        {name}
      </span>
      <span className="col-span-3 md:col-span-2 text-right">{formatCurrency(price)}</span>
    </div>
  );
}
